export default "__VITE_ASSET__D9vtmMaQ__"